import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { canAccessContentLibrary } from 'features/content-library/canAccessContentLibrary';

export const useContentLibrary = () => {
  const featureEnabled = useFeatureFlag('contentLibrary');

  const { hasPermissions } = usePermissions();
  const canManageLibrary = hasPermissions(PermissionTypes.manageContentLibrary);

  const canPresentLibrary = hasPermissions(PermissionTypes.presentContentLibrary);

  const canManagePersonalContentLibrary = hasPermissions(
    PermissionTypes.managePersonalContentLibrary
  );
  const isFeatureAvailable = canAccessContentLibrary({ contentLibraryEnabled: featureEnabled });

  const sharedContentOnlyAvailable = !canManageLibrary && !canManagePersonalContentLibrary;

  return {
    canManageLibrary,
    isFeatureAvailable,
    canManagePersonalContentLibrary,
    canPresentLibrary,
    sharedContentOnlyAvailable,
  };
};
